
import { Vue, Component, Prop } from 'vue-property-decorator'
import Store from '@/store'
import ProductForm from '@/components/ProductComponents/ProductForm.vue'

@Component({
  components: {
    ProductForm
  }
})
export default class ActionsForDevice extends Vue {
  public dialogDrop = false
  public valid = true
  public loading = false

  @Prop()
  public readonly value!: any

  onClickClose() {
    this.dialogDrop = false
  }

  public async handleDisable() {
    Store.commit('openProduct/mutate', {
      property: 'openDevice.id',
      with: this.value
    })
    await Store.dispatch('openProduct/disableDevice')
    Store.dispatch('openProduct/fetchDevices', () => true)
  }
}
